
const genderValueEnum = {
 MALE: {id: 1, label: 'Male', value: 'Male'},
 FEMALE: {id: 2, label: 'Female', value: 'Female'},
}

export default genderValueEnum;